import "./SnackIndustry.module.css";
import Header from "@/reusable_sections/Header";
import Eurocontrol from "./sections/Eurocontrol";
import TechnicalAdvantages from "./sections/TechnicalAdvantages";
import ProductShowcase from "./sections/ProductShowcase";
import Footer from "@/reusable_sections/Footer";
export default function SnackIndustryPage() {
  return <div>
      <Header />
      
      <Eurocontrol />
      <TechnicalAdvantages />
      <ProductShowcase />
      <Footer />
    </div>;
}